import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { getVenues } from '../../../api/VenuesAPI';
import { createTurfBooking, fetchTurfBooking, updateTurfBooking } from '../../../api/TurfBookingsAPI';
import { handleApiError } from '../../../api/risapi';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppToaster from '../../../components/AppToaster';

const TurfBookingsForm = ({ formType }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [booking, setBooking] = useState({
        booking_name: '',
        venue_id: null,
        booked_on: new Date().toISOString().slice(0, 10),
        notes: '',
        slots: [{ slot_date: '', start_time: '', end_time: '', cost: '0' }]
    });
    const [venues, setVenues] = useState([]);
    const [selectedVenue, setSelectedVenue] = useState(null);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    const isEditMode = formType === 'edit';

    useEffect(() => {
        getVenues({ paginate: false }, (response) => {
            if (response.venues) {
                setVenues(response.venues.map(v => ({ value: v.id, label: v.name })));
            }
        });
    }, []);

    useEffect(() => {
        if (isEditMode && id) {
            setIsLoading(true);
            fetchTurfBooking(id, (response) => {
                setIsLoading(false);
                if (response.turf_booking) {
                    const { booking_slots, venue, ...mainBookingData } = response.turf_booking;
                    setBooking({ ...mainBookingData, slots: booking_slots });
                    setSelectedVenue({ value: venue.id, label: venue.name });
                }
            });
        }
    }, [id, isEditMode]);
    
    const handleMainInputChange = (e) => {
        const { name, value } = e.target;
        setBooking(prev => ({ ...prev, [name]: value }));
    };

    const handleSlotInputChange = (index, e) => {
        const { name, value } = e.target;
        const newSlots = [...booking.slots];
        newSlots[index][name] = value;
        setBooking(prev => ({ ...prev, slots: newSlots }));
    };

    const addSlot = () => {
        setBooking(prev => ({
            ...prev,
            slots: [...prev.slots, { slot_date: '', start_time: '', end_time: '', cost: '0' }]
        }));
    };

    const removeSlot = (index) => {
        if (booking.slots.length <= 1) return; // Prevent removing the last slot
        const newSlots = booking.slots.filter((_, i) => i !== index);
        setBooking(prev => ({ ...prev, slots: newSlots }));
    };

    const handleSubmit = (exitForm) => {
        setIsLoading(true);
        setErrors({});
        const dataToSend = { ...booking, venue_id: selectedVenue?.value };
        const apiCall = isEditMode ? updateTurfBooking : createTurfBooking;

        apiCall(dataToSend, (response) => {
            setIsLoading(false);
            if (response.turf_booking) {
                const message = `Booking ${isEditMode ? 'updated' : 'created'} successfully!`;
                if (exitForm) {
                    navigate('/club_portal/bookings', { state: { message } });
                } else {
                    setToaster({ type: 'success', heading: 'Success', message });
                    setShowToaster(true);
                    setBooking({
                        booking_name: '', venue_id: null, booked_on: new Date().toISOString().slice(0, 10), notes: '',
                        slots: [{ slot_date: '', start_time: '', end_time: '', cost: '0' }]
                    });
                    setSelectedVenue(null);
                }
            } else {
                handleApiError(response, setErrors);
            }
        });
    };

    return (
        <main>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <div className="container-fluid">
                <AppBreadCrumb title={isEditMode ? 'Edit Turf Booking' : 'Create Turf Booking'} />
                <div className="card">
                    <div className="card-header"><h5>Booking Details</h5></div>
                    <div className="card-body">
                        <form className="app-form">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Booking Name *</label>
                                    <input type="text" name="booking_name" className="form-control" value={booking.booking_name} onChange={handleMainInputChange} />
                                    {errors.booking_name && <div className="text-danger small">{errors.booking_name}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Booked On Date *</label>
                                    <input type="date" name="booked_on" className="form-control" value={booking.booked_on} onChange={handleMainInputChange} />
                                    {errors.booked_on && <div className="text-danger small">{errors.booked_on}</div>}
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Venue *</label>
                                    <Select options={venues} value={selectedVenue} onChange={setSelectedVenue} placeholder="Select a venue..." />
                                    {errors.venue_id && <div className="text-danger small">{errors.venue_id}</div>}
                                </div>
                                
                                <div className="col-12"><hr/><h5>Booking Slots</h5></div>
                                
                                {booking.slots.map((slot, index) => (
                                    <div key={index} className="row align-items-center mb-3 border-bottom pb-3">
                                        <div className="col-md-3"><input type="date" name="slot_date" value={slot.slot_date} onChange={(e) => handleSlotInputChange(index, e)} className="form-control" />{errors[`slots.${index}.slot_date`] && <div className="text-danger small">{errors[`slots.${index}.slot_date`]}</div>}</div>
                                        <div className="col-md-3"><input type="time" name="start_time" value={slot.start_time} onChange={(e) => handleSlotInputChange(index, e)} className="form-control" />{errors[`slots.${index}.start_time`] && <div className="text-danger small">{errors[`slots.${index}.start_time`]}</div>}</div>
                                        <div className="col-md-3"><input type="time" name="end_time" value={slot.end_time} onChange={(e) => handleSlotInputChange(index, e)} className="form-control" />{errors[`slots.${index}.end_time`] && <div className="text-danger small">{errors[`slots.${index}.end_time`]}</div>}</div>
                                        <div className="col-md-2"><input type="number" name="cost" value={slot.cost} onChange={(e) => handleSlotInputChange(index, e)} className="form-control" placeholder="Cost" />{errors[`slots.${index}.cost`] && <div className="text-danger small">{errors[`slots.${index}.cost`]}</div>}</div>
                                        <div className="col-md-1"><button type="button" className="btn btn-danger btn-sm" onClick={() => removeSlot(index)} disabled={booking.slots.length <= 1}><i className="fas fa-trash"></i></button></div>
                                    </div>
                                ))}
                                <div className="col-12 mb-3"><button type="button" className="btn btn-outline-primary btn-sm" onClick={addSlot}><i className="fas fa-plus me-2"></i>Add Another Slot</button></div>

                                <div className="col-12 text-end">
                                     {!isEditMode ? (
                                        <>
                                            <button type="button" className="btn btn-outline-primary me-2 btn-sm" onClick={() => handleSubmit(false)}>Save + Next</button>
                                            <button type="button" className="btn btn-primary me-2 btn-sm" onClick={() => handleSubmit(true)}>Save + Exit</button>
                                        </>
                                    ) : (
                                        <>
                                            <button type="button" className="btn btn-primary me-2 btn-sm" onClick={() => handleSubmit(true)}>{isLoading ? 'Updating...' : 'Update Booking'}</button>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={() => navigate('/club_portal/bookings')}>Cancel</button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default TurfBookingsForm;

